import React, { useEffect, useState } from 'react';
import backendApi from "../../../utils/BackendApi.js";
import { useTranslation } from 'react-i18next';
import iconInfo from "../../../../img/icon_info.svg";
import uploadIcon from '../../../../img/upload-file.svg';
import { Tooltip } from 'react-tooltip'
import { FaSpinner } from 'react-icons/fa';
import {toast } from 'react-toastify';


function DesignRequestsPage() {
  const [t] = useTranslation("global");
  const [designRequests, setDesignRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sendingIndex, setSendingIndex] = useState(null);
  const [cadLoadingIndex, setCadLoadingIndex] = useState(null);

//  const pathToCadPage = "https://design.domino-design.it/project/";
  const pathToCadPage = "https://design.domino-design.it/design/";

   const fetchRequests = async () => {
         try {
           const res = await backendApi.get('/api/design-requests?status=PENDING');
           console.log("Design requests fetched:", res.data);
           setDesignRequests(res.data);
         } catch (err) {
           console.error("Error loading design requests", err);
         } finally {
           setLoading(false);
         }
       };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleCreateQuote = async (designId) => {
    try {
      await backendApi.post(`/api/design-requests/${designId}/create-quote`);
      alert(`Quote request created for design ID: ${designId}`);
    } catch (err) {
      console.error("Error creating quote", err);
      alert("Failed to create quote.");
    }
  };

  const sendQuotationToBackend = async (item, index) => {
    if (!item.dmsClientId || item.dmsClientId === "N/A") {
      toast.error("Il cliente non esiste nel DMS.");
      return;
    }

    try {
      const response = await backendApi.post("/api/multitenant/design/sendQuotation", {
        url: item.id?.url,
        negotiation_id: item.id?.negotiationId,
        design_id: item.id?.designId,
        dmsClientId: item.dmsClientId,
      });

      console.log("Quotation creation response:", response.data);
      await fetchRequests(); // aggiorna la lista
    } catch (error) {
      console.error("Error sending quotation:", error);
    }
  };


  const updateDesignRequests = () => {
    fetchRequests();
  };

  const showErrorFun = (message) => {
    toast.error(message);
  };

  function formatDateTime(date) {
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  // Funzione per verificare se l'estensione è installata e impostare i cookie
    const handleCheckAndSetCookie = (username, cadId, index) => {
      let responded = false;
      setCadLoadingIndex(index); // Imposta loading
      console.log("handleCheckAndSetCookie",username, cadId);

      const listener = (event) => {
        console.log("listener: "+JSON.stringify(event));
        if (event.data.action === "extension_status") {
          //console.log("L'estensione ha risposto");
          responded = true; // Segnaliamo che l'estensione ha risposto
          if (!event.data.installed) {
            showErrorFun(t("components.largeSquareButton.errors.generalCookiesError"));
            setCadLoadingIndex(null);
          } else {
            setCookie(username, cadId); // Se l'estensione è installata, imposta i cookie
          }
          window.removeEventListener("message", listener);
        }
      };

      window.addEventListener("message", listener);
      window.postMessage({ action: "check_extension" }, "*");

      // Timeout se non riceviamo risposta in 3 secondi
      setTimeout(() => {
        console.log("Timeout: "+JSON.stringify(responded))
        if (!responded) {
          showErrorFun(t("components.largeSquareButton.errors.missingWebExtension"));
          window.removeEventListener("message", listener);
          setCadLoadingIndex(null);
        }
      }, 3000);
    };

    // Funzione per invocare l'API e settare i cookie
    const setCookie = async (username, cadId) => {
      try {
          if (!username) {
            showErrorFun(t("components.largeSquareButton.errors.generalCookiesError"));
            setCadLoadingIndex(null);
            return;
          }

        const response = await backendApi.get("api/set-cookie?username="+encodeURIComponent(username));

        if (response.status !== 200) {
          throw new Error("Errors on cookies!");
          //ti dovrebbe buttare fuori
        }

        const cookies = response.data;
        console.log("Cookie ricevuti dal backend:", cookies);

        if (!Array.isArray(cookies) || cookies.length === 0) {
          showErrorFun(t("components.largeSquareButton.errors.missingWebExtension"));
          setCadLoadingIndex(null);
          return;
        }

        // Itera sui cookie ricevuti e li invia all'estensione
        cookies.forEach((cookie) => {
          window.postMessage(
            {
              action: "setCookie",
              cookieDetails: {
                url: "https://productionbackend.infurnia.com", // Imposta l'URL usando il dominio del cookie
                name: cookie.name,
                value: cookie.value,
                domain: cookie.domain,
                path: cookie.path,
                expires: cookie.expires, // Assumendo che sia già un numero (timestamp Unix)
                secure: cookie.secure,
                httpOnly: cookie.httpOnly,
                sameSite: cookie.sameSite,
              },
            },
            "*"
          );
        });

        // ✅ Apro il CAD solo dopo che i cookie sono stati inviati all'estensione
        if (cadId) {
          window.open(pathToCadPage + cadId, "_blank");
        }

      } catch (error) {
        console.error("Errore:", error);
        showErrorFun(t("components.largeSquareButton.errors.generalCookiesError"));
      }finally {
           setCadLoadingIndex(null);
         }
    };


  if (loading) return <p>Loading...</p>;

  return (
    <div className="private-page design-requests">
      <div className="row-actions">
        <div>
          <h2 className="mb-2">
            <b>{t("agentNavBar.designRequests")}</b>
          </h2>
        </div>
      </div>

      <div className="header-quotations">
        <h4 className="m0">
          <b>{t("agentNegotiationDetailsPage.quotations")}</b>
        </h4>
        <button className="toast_onpage small" onClick={updateDesignRequests}>
          <img src={iconInfo} />
          {t("agentNegotiationDetailsPage.toastUpdateList")}{" "}
          <span>{t("agentNegotiationDetailsPage.toastUpdateListCta")}</span>
        </button>
      </div>

      <table className="private-table">
        <thead>
          <tr>
            <th>{t("designRequestsPage.username")}</th>
            <th>{t("designRequestsPage.clientID")}</th>
            <th>{t("designRequestsPage.negotiationId")}</th>
            <th>{t("designRequestsPage.DesignId")}</th>
            <th>{t("designRequestsPage.negotiationTitle")}</th>
            <th>{t("designRequestsPage.designName")}</th>
            <th>{t("designRequestsPage.createdAt")}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {designRequests.map((req, index) => (
            <tr key={req.design_id}>
              <td>{req.username}</td>
              <td>{req.dmsClientId}</td>
              <td>{req.id?.negotiationId}</td>
              <td>{req.id?.designId}</td>
              <td>{req.negotiationTitle}</td>
              <td>{req.designName}</td>
              <td>{formatDateTime(new Date(req.createdAt))}</td>
              <td className="table-cell-action action">
                {/*<button
                  className="icon-button-round"
                  onClick={() => handleCreateQuote(req.design_id)}
                  data-tooltip-id="tooltipCreate"
                  data-tooltip-content={t("agentNegotiationDetailsPage.createQuotation")}
                  data-tooltip-delay-show={500}
                >
                  <img width={28} height={28} src={uploadIcon} />
                  <Tooltip className="tooltip" id="tooltipCreate" place="bottom" />
                </button>*/}
                <button
                    className="icon-button-round"
                    data-tooltip-id="tooltipSubmit"
                    data-tooltip-content="Invia preventivo al DMS"
                    data-tooltip-delay-show={500}
                    onClick={async () => {
                      if (sendingIndex === index) return;
                      setSendingIndex(index);
                      try {
                        await sendQuotationToBackend(req, index);
                      } finally {
                        setSendingIndex(null);
                      }
                    }}
                    disabled={sendingIndex === index}
                    style={{
                      cursor: sendingIndex === index ? 'not-allowed' : 'pointer',
                      opacity: sendingIndex === index ? 0.6 : 1,
                    }}
                  >
                    {sendingIndex === index ? (
                      <FaSpinner className="spinner" size={28} />
                    ) : (
                      <img width={28} height={28} src={uploadIcon} />
                    )}
                    <Tooltip className="tooltip" id="tooltipSubmit" place="bottom" />
                  </button>
              </td>
              <td>
                {/* Bottone: Vai al CAD */}
                <button
                  className="btn-cad"
                  onClick={() => handleCheckAndSetCookie(req.username, req.cadId, index)}
                    disabled={cadLoadingIndex === index}
                      style={{
                        cursor: cadLoadingIndex === index ? 'not-allowed' : 'pointer',
                        opacity: cadLoadingIndex === index ? 0.6 : 1,
                      }}
                    >
                  {cadLoadingIndex === index ? (
                    <FaSpinner className="spinner" size={28} />
                  ) : (
                    <span>Vai al CAD</span>
                  )}

                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

}

export default DesignRequestsPage;
